/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb5_DescriptionInputs */

const en_visa_eb5_description = /** @type {(inputs: Visa_Eb5_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The EB-5 Immigrant Investor Program can provide a path to permanent residence through a qualifying investment in a new commercial enterprise, subject to investment, job-creation, and source-of-funds requirements under current law.`)
};

const pt_visa_eb5_description = /** @type {(inputs: Visa_Eb5_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Programa de Investidor Imigrante EB-5 pode oferecer um caminho para a residência permanente por meio de um investimento que atenda aos requisitos em uma nova empresa comercial, sujeito às exigências de investimento, criação de empregos e origem dos recursos previstas na legislação vigente.`)
};

const es_visa_eb5_description = /** @type {(inputs: Visa_Eb5_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El Programa de Inversor Inmigrante EB-5 puede proporcionar un camino hacia la residencia permanente a través de una inversión calificada en una nueva empresa comercial, sujeto a los requisitos de inversión, creación de empleos y origen de fondos bajo la ley actual.`)
};

/**
* | output |
* | --- |
* | "The EB-5 Immigrant Investor Program can provide a path to permanent residence through a qualifying investment in a new commercial enterprise, subject to inve..." |
*
* @param {Visa_Eb5_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb5_description = /** @type {((inputs?: Visa_Eb5_DescriptionInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb5_DescriptionInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb5_description(inputs)
	if (locale === "es") return es_visa_eb5_description(inputs)
	return en_visa_eb5_description(inputs)
});